export { default as EditProfile } from './EditProfile'
export { default as Logout } from './Logout'
export { default as ViewPrivate } from './ViewPrivate'
export { default as ViewPublic } from './ViewPublic'


// WEBPACK FOOTER //
// ./src/js/views/Profile/components/ActionButtons/components/index.js